<template>
  <div class="dashboard">
    <Payment :contractNumber="contractNumber" modalId="paymentModalFeedbackbar" />
    <div class="container-fluid bg-dark responsive-side-padding no-margin-top">
      <div class="container-boxed-layout" v-if=" $store.getters.hasDueBills">
        <EgyenlegRendben v-if="$store.state.dueBills.amount == 0">
          <template v-slot:picture>
            <img src="@/assets/img/clientzone/icon/true.svg" />
          </template>
          <template v-slot:content>{{ content.get('allPayed') }}</template>
        </EgyenlegRendben>
        <EgyenlegFizetese v-else>
          <template v-slot:picture>
            <img src="@/assets/img/clientzone/illustration/esedekes.svg" />
          </template>
          <template v-slot:header>{{ content.get('toPay') }}</template>
          <template v-slot:amount>{{ formatNumber($store.state.dueBills.amount) }} Ft</template>
          <template v-slot:headerMiddle>{{ content.get('appliableContract') }}</template>
          <template v-slot:amountMiddle>{{ $store.state.dueBills.pieces }} db</template>
          <template v-slot:transaction>
            <div class="row mresp-img-p" v-if="$store.state.dueBills.pieces > 0 && $store.state.dueBills.inProgress">
              <v-icon color="white">autorenew</v-icon>
              <p class="transaction-white">{{ content.get('paymentInProgress') }}</p>
            </div>
            <button v-else
              type="button"
              class="btn btn-filled btn-minwidth"
              @click="navigateToBills"
            >{{ content.get('details') }}</button>
          </template>
          <!-- <template v-slot:transaction v-if="$store.state.dueBills.pieces == 1">
            <div class="row mresp-img-p" v-if="$store.state.dueBills.inProgress">
              <v-icon color="white">autorenew</v-icon>
              <p class="transaction-white">{{ content.get('paymentInProgress') }}</p>
            </div>
            <button
             v-else
              type="button"
              class="btn btn-filled"
              data-toggle="modal"
              data-target="#paymentModalFeedbackbar"
              @click="setContractNumber($store.state.dueBills.contractNumbers[0])"
            >{{ content.get("payment") }}</button>
          </template> -->
        </EgyenlegFizetese>
      </div>
      <div class="container-boxed-layout" v-else>
        <MiniLoadingIndicator :className="'loading-icon'" />
      </div>
    </div>
  </div>
</template>

<script>
import EgyenlegFizetese from "@/components/layout/EgyenlegFizetese";
import EgyenlegRendben from "@/components/layout/EgyenlegRendben";
import MiniLoadingIndicator from "@/components/MiniLoadingIndicator";
import Payment from "@/components/Payment";
import Api from "@/api/api";
import Feedback from "@/feedback";
import ContentMixin from "../mixins/ContentMixin";
import LoadingMixin from "../mixins/LoadingMixin";
import PaymentMixin from "../mixins/PaymentMixin";

const api = new Api();

export default {
  components: {
    EgyenlegFizetese,
    EgyenlegRendben,
    MiniLoadingIndicator,
    Payment,
  },
  mixins: [ContentMixin, LoadingMixin, PaymentMixin],
  data() {
    return {
      contractNumber: NaN,
    };
  },
  created: async function () {
    await this.loadContent("accountBalance");
    if (this.$store.state.transactionID) {
      this.loadingOn();
      let transactionId = this.$store.state.transactionID;
      this.$store.commit("setTransactionID", null);
      await this.initPayment(transactionId);
      this.loadingOff();
    }
  },
  methods: {
    setContractNumber(contractNumber) {
      this.contractNumber = contractNumber;
    },
    sleep: function (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    initPayment: async function (transactionID) {
      while ((await this.checkTransaction(transactionID)) === "InProgress") {
        await this.sleep(10000);
      }
      await this.navigateToFeedbackPage();
    },
    checkTransaction: async function (transactionID) {
      let data = await api.checkTransaction(transactionID);
      let feedBackPage = await this.getPageContent("visszaigazolo-kepernyo");
      if (data.state === "Done") {
        this.$store.commit(
          "setFeedback",
          new Feedback(
            "/",
            feedBackPage.get("otpSuccess"),
            "",
            feedBackPage.get("backToHome"),
            1,
            data.message
          )
        );
        this.$store.commit("setDueBills", await api.dueBills());
      } else if (data.state === "Failed") {
        this.$store.commit(
          "setFeedback",
          new Feedback(
            "/",
            feedBackPage.get("otpFailure"),
            "",
            feedBackPage.get("backToHome"),
            3,
            data.message
          )
        );
      }
      return data.state;
    },
    navigateToBills() {
      const path = "/levelek";
      if (this.$route.path !== path) this.$router.push(path);
    },
  },
};
</script>
